import React from "react";
import { FaFacebook, FaInstagram, FaTiktok, FaRegCopyright } from "react-icons/fa";
import "./footer.css";

function Footer() {
  return (
    <div className="footer">
        <p>
            <b>©</b> 2024 BUYERS GALAXY. ALL RIGHTS RESERVED.
        </p>
        <div className="icon-container">
            <a href="https://www.facebook.com/buyersgalaxy/" target="_blank" rel="noopener noreferrer" className="icon">
                <FaFacebook />
            </a>
            <a href="https://www.instagram.com/buyersgalaxy/" target="_blank" rel="noopener noreferrer" className="icon instagram">
                <FaInstagram />
            </a>
            <a href="https://www.tiktok.com/@buyersgalaxy" target="_blank" rel="noopener noreferrer" className="icon tiktok">
                <FaTiktok />
            </a>
        </div>
        <p>
            PRIVACY <span>POLICY</span> | SITE<span>MAP</span>
        </p>
    </div> 
  );
}
export default Footer;
